/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Login_DescriptionInputs */

const en_auth_login_description = /** @type {(inputs: Auth_Login_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign in to your account to continue`)
};

const es_auth_login_description = /** @type {(inputs: Auth_Login_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inicia sesion en tu cuenta para continuar`)
};

/**
* | output |
* | --- |
* | "Sign in to your account to continue" |
*
* @param {Auth_Login_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const auth_login_description = /** @type {((inputs?: Auth_Login_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Login_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_auth_login_description(inputs)
	return es_auth_login_description(inputs)
});